module.exports = __webpack_public_path__ + "static/wpack/extracted/Penguins18a513aa737f75006ce4bd279d8e79d0.png";